import React, { Component } from 'react'

class GoogleMaps extends Component {


  constructor(props){
    super(props)

    this.state = {
        map: null,
        geocoder:null,
        markers:[],
        markerList:[],
        markerCluster:false,
        enableMap:false,
        mapUpdatedTimeout:false

    }

    this.initMap = this.initMap.bind(this)
    this.updateMarkers = this.updateMarkers.bind(this);
    this.searchForPlace = this.searchForPlace.bind(this);
    this.geoCodeAddressResult = this.geoCodeAddressResult.bind(this)
    this.findClosestMarker = this.findClosestMarker.bind(this);

    this.clusterZoom = this.clusterZoom.bind(this)

    this.highLightMarker = this.highLightMarker.bind(this)

    this.nonAPIgetDistance  = this.nonAPIgetDistance.bind(this)

    this.getMarkersOnMap = this.getMarkersOnMap.bind(this)

    this.mapUpdated = this.mapUpdated.bind(this)



  }


  componentDidMount(){

    this.addScript();
  }

  addScript(){




    // Dont include the script more than onece
    if(!document.getElementById('googlemapsscript')){
    var script = document.createElement( 'script' );

    script.setAttribute('async',null)
    script.setAttribute('defer',null)
    script.setAttribute('id','googlemapsscript')

    let key = 'AIzaSyAjgHV94kkPCqDiGZejoMDO6VenculJsgw'
        key ='AIzaSyBw1LzziatUbg1uBRWvNlURbLDvJgQ75wk'

    script.src = 'https://maps.googleapis.com/maps/api/js?key='+key+'&callback=initMap&v=3.exp&libraries=geometry';
    document.body.appendChild( script );


    var clusterScript = document.createElement( 'script' );
    clusterScript.setAttribute('async',null)
    clusterScript.setAttribute('defer',null)
    clusterScript.setAttribute('id','clusterscript')
    clusterScript.src="https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"
    document.body.appendChild( clusterScript );

    window.initMap = this.initMap

    }else{
      //console.log("Google Maps, script allready loaded.");
      this.initMap()
    }
  }

  initMap(){
    //console.log('Init Map');

    //43.344208, -35.078944

    let zoomLevel = 2

    if(window.innerWidth>1200){
      zoomLevel = 3
    }

    var worldCenter = {lat: 43.344208, lng: 0};
        let map = new window.google.maps.Map(document.getElementById('map'), {
         zoom: zoomLevel,
         center: worldCenter,
         maxZoom:14,
         styles: BrixtonMapStyle,
         //disableDefaultUI: true
         zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          viewport:null,

       });

       var geocoder = new window.google.maps.Geocoder();


       // Add Listner

         map.addListener('dragend',(e)=>{
            console.log('drag end')
            //this.getMarkersOnMap(e);
          })

          map.addListener('zoom_changed',(e)=>{
            //console.log('zoom_changed')
              //this.getMarkersOnMap(e);
          })

         
       this.setState({map,geocoder})
  }


  mapUpdate(){

      clearTimeout(this.state.mapUpdatedTimeout)


      let mapUpdatedTimeout = setTimeout(()=>{
        //console.log('Map View Updated');
        this.mapUpdated()
      },500)


      this.setState({mapUpdatedTimeout})
  }

   mapUpdated(){




      let markerList = this.getMarkersOnMap()



       this.setState({markerList})
        this.forceUpdate();

        this.updateMarkers();
  }


  getMarkerLatLong(curr){


     // Look for ',' instead of '.'
        if(curr.acf.lat){
          if(curr.acf.lat.indexOf(',')!==-1){
            curr.acf.lat = curr.acf.lat.split(',').join('.')
          }
        }
        if(curr.acf.long){
          if(curr.acf.long.indexOf(',')!==-1){
            curr.acf.long = curr.acf.long.split(',').join('.')
          }
        }




        let currentLat = Number(curr.acf.lat);
        let currentLong = Number(curr.acf.long);

        // use other lat and lang if current one not available


        if(curr.acf.use_custom_pin_position){
          //console.log("use custom position",currentLat,currentLong);
          currentLat = (curr.acf.map.lat);
          currentLong = (curr.acf.map.lng);

          //console.log("use custom position UPDATED",currentLat,currentLong);

          //console.log('Custom Pos ',currentLat,currentLong,curr.acf.map);

        }


        return {lat:currentLat,lng:currentLong }


  }

  


  getMarkersByDistance(){
       let allMarkers = this.props.markerList.slice(); 





        //console.log("Get Markers On Map",this.state.map.getBounds())

        //console.log("center?",this.state.map.getCenter().lat())



        let center = new window.google.maps.LatLng({lat: this.state.map.getCenter().lat(), lng: this.state.map.getCenter().lng()});


        let centerLat = this.state.map.getCenter().lat();
        let centerLng = this.state.map.getCenter().lng()

            // calculate distance 


        let bounds = this.state.map.getBounds()


      // set the distance 


       allMarkers = allMarkers.filter((item)=>{

          let pos = this.getMarkerLatLong(item)
          item.currentPosition = new window.google.maps.LatLng(pos.lat, pos.lng)
          item.distance = window.google.maps.geometry.spherical.computeDistanceBetween(center,  item.currentPosition);
          return true 
      })

      // order by distance 

       allMarkers =  allMarkers.sort((a, b)=>{
          return a.distance - b.distance;
        })

       return allMarkers
  }


  getMarkersOnMap(e){


    
      let allMarkers = this.getMarkersByDistance();


       let bounds = this.state.map.getBounds()
      let markersOnMap  = allMarkers.filter((item)=>{
            ///curr.onMap = 

            //console.log( bounds.contains(currentPosition))


            return bounds.contains(item.currentPosition)
       })

        //console.log('Markes on Map',markersOnMap, markersOnMap)

        


        // there is no result, get the 5 closest

        if(allMarkers.length===0){


        }


        

          return markersOnMap

       

  }


  findNearbyMarkers(markersOnMap){

       let allMarkers = this.getMarkersByDistance();

          console.log('Check if there are any markers, nearby ish..')


           let closestMarkers = allMarkers.slice(markersOnMap.length); 
           let center = new window.google.maps.LatLng({lat: this.state.map.getCenter().lat(), lng: this.state.map.getCenter().lng()});



           closestMarkers = closestMarkers.filter((item,k)=>{

                ///console.log(item.title.rendered, item.distance)

                if(item.distance < 200000 ){
                  return true
                }
           })


           console.log('closestMarkers',closestMarkers)


           markersOnMap = markersOnMap.concat(closestMarkers)


           this.updateMapBounds(markersOnMap,center)



         return markersOnMap
  }

  updateMapBounds(markers,center){

       console.log("update bounds")

          let bounds = this.state.map.getBounds()

        markers.map((marker,i)=>{

         bounds.extend(marker.currentPosition);

          //console.log('distance',item.title.rendered,item.distance/1000);
        })

        bounds.extend(center);

        //console.log("Find the closest markers",markersOnMap);

        //this.state.map.setZoom(10);

        //console.log('bounds',bounds);
        this.state.map.fitBounds(bounds, {top:75,right:40,left:40,bottom:40});
  }

  updateMarkers(){

    //console.log("Marker List",this.props.markerList);

    console.log("update markers")
    if(this.props.markerList && this.state.map){

        // clear markers first
        //window.setMapOnAll(null);

        //console.log(this.state.map);

        //Loop through all the markers and remove

        let markerOnMapAllready = false;

        for (let i = 0; i < this.state.markers.length; i++) {

            //console.log(this.state.markers[i].title)


            this.state.markerList.map((item,k)=>{

                    if('marker'+item.id===this.state.markers[i].title){
                        markerOnMapAllready = true;
                    }
            })


            if(!markerOnMapAllready){
             this.state.markers[i].setMap(null);
           }


        }

        let markers = []

        let bounds = new window.google.maps.LatLngBounds();

        let activeMarkerPosition

        //console.log("Marker Length",this.props.markerList.length);

        this.state.markerList.map((dealerMarker,i)=>{


          //console.log('marker',dealerMarker.acf);
          //if(dealerMarker.acf.lat,dealerMarker.acf.map.lng)

          let lat = dealerMarker.acf.lat
          let long = dealerMarker.acf.long


          if(dealerMarker.acf.use_custom_pin_position){
            //console.log("use custom position",lat,long);
            lat = (dealerMarker.acf.map.lat);
            long = (dealerMarker.acf.map.lng);

            //console.log("use custom position UPDATED",lat,long);

            //console.log('Custom Pos ',currentLat,currentLong,curr.acf.map);

          }


          let myLatlng = new window.google.maps.LatLng(lat,long);



          // pick image depending on there is an active marker.

          let imageIcon = 'assets/images/mapmarker.png'
               imageIcon = 'mapmarker.png'
               imageIcon = '/dealerapp/mapmarker.png'



          // check if the marker is allready on screen

          let marker 

          markerOnMapAllready = false

           this.state.markers.map((item,k)=>{


                    if(item.title==='marker'+this.state.markerList[i].id){
                        markerOnMapAllready = true;
                        marker = item
                    }
            })



           if(!markerOnMapAllready){

              console.log("New Marker")
               marker = new window.google.maps.Marker({
                      position: myLatlng,
                      title: 'marker'+dealerMarker.id,
                      icon: imageIcon,
                  });



                 marker.addListener('click',()=>{
                      //console.log("Cliked on",dealerMarker);
                      this.props.markerClick(dealerMarker.id)
                   })

                   marker.addListener('mouseover',()=>{
                    this.props.markerHover(dealerMarker.id)
                   })

                   marker.addListener('mouseout',()=>{
                      //console.log("rolled out",dealerMarker);
                      this.props.markerRollOff(dealerMarker.id)
                   })

                // To add the marker to the map, call setMap();
                marker.setMap(this.state.map);

             }



             if(this.props.activeMarker.id){
                   //console.log(this.props.activeMarker.id);
                 if(this.props.activeMarker.id !== dealerMarker.id){
                      marker.setOpacity(0.5);
                 }else{

                   activeMarkerPosition = myLatlng

                   this.setState({activeMarkerPosition})
                 }
             }




          markers.push(marker)

          bounds.extend(myLatlng);



        })

        //if(!activeMarkerPosition){
          this.setupClusters(markers)
        //}

        if(activeMarkerPosition){

          // Moved to centerOnActiveMarker()

          //this.state.map.setCenter(activeMarkerPosition)
          //this.state.map.setZoom(13);
          //this.state.map.panBy(this.findCenterOfScreen(),0)

        }


        this.setState({markers})
        //this.state.map.fitBounds(bounds);
        //this.state.map.setZoom(10);


        // Send the dealers back to the parent
        this.props.setCurrentDealers(this.state.markerList)

        if(markers.length===1){

          //this.state.map.setCenter(markers[0].position);

        }

        ///console.log("markers",markers);



    }

  }

  centerOnActiveMarker(){
        


      this.state.markerList.map((dealerMarker,i)=>{




            if(this.props.activeMarker.id){


           
            if(this.props.activeMarker.id === dealerMarker.id){

               console.log("Center on ", dealerMarker)

                 let position =  this.getMarkerLatLong(dealerMarker)


                    //let  activeMarkerPosition

                   let activeMarkerPosition = new window.google.maps.LatLng(position.lat,position.lng);

                  if(activeMarkerPosition){

                      this.state.map.setCenter(activeMarkerPosition)
                      this.state.map.setZoom(13);
                      this.state.map.panBy(this.findCenterOfScreen(),0)

                    }
                  }
                }
            });

        
  }

  highLightMarker(id){


    // Check to see if there is an active marker on de-hightlight
    if(!id && this.props.activeMarker.id){
      id = this.props.activeMarker.id;
    }


    //console.log("highLightMarker",id);


    if(id){

      this.state.markers.map((marker,i)=>{
        //console.log('marker',marker);
        if(marker.title===('marker'+id)){
            marker.setOpacity(1);
        }else{
            marker.setOpacity(0.5);
        }
      });


    }else{
      this.state.markers.map((marker,i)=>{
            marker.setOpacity(1);
      });
    }
  }

  setupClusters(markers){



            let imagePath = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
        //imagePath = 'https://brixton.stageserver.co.uk/assets/map/m'
        imagePath = 'assets/map/m'
        imagePath = '/dealerapp/m'

    let mcOptions = {
      gridSize: 50,
      maxZoom: 15,
      imagePath
    };

    //if(!this.state.markerCluster){
      if(this.state.markerCluster){
        this.state.markerCluster.clearMarkers();
      }
      let markerCluster = new window.MarkerClusterer(this.state.map, markers, mcOptions);
      window.google.maps.event.addListener(markerCluster, 'clusterclick', this.clusterZoom);
      this.setState({markerCluster})
  //  }else{
  //    console.log("Cluster Reboot");
  //    this.state.markerCluster.clearMarkers();
  //    this.state.markerCluster.addMarkers(markers)
  //  }

  }
  clusterZoom(cluster){
    //alert('Zoom!')
    this.state.map.setCenter(cluster.getCenter());
    this.state.map.setZoom(this.state.map.getZoom()+1);

    this.state.map.panBy(this.findCenterOfScreen(),0)
  }


  findCenterOfScreen(){

        // find the center of the maps with adjustment for the dealer list

        let mapCenterX = 0;

        let screenCenter = window.innerWidth / 2

        if(window.innerWidth>=1540){
            mapCenterX =   (1240 / 6)
        }

        if(window.innerWidth < 1540){

            mapCenterX  = (window.innerWidth-240)/6
        }

        if(window.innerWidth < 1025){

            mapCenterX  = (window.innerWidth-120)/6
        }
        if(window.innerWidth < 769){

            mapCenterX  = (window.innerWidth-60)/6
        }

        //console.log('mapCenterX',mapCenterX);

        return mapCenterX;
  }

  searchForPlace(){

      console.log('Search', this.props.searchTerm);

      let address = this.props.searchTerm;
        this.state.geocoder.geocode({'address': address},this.geoCodeAddressResult);


  }

  geoCodeAddressResult(results, status) {
      if (status === 'OK') {

        console.log("geoCodeAddressResult",results);

        this.state.map.setCenter(results[0].geometry.location);
        var marker = new window.google.maps.Marker({
          map: this.state.resultsMap,
          position: results[0].geometry.location
        });

        let bounds = new window.google.maps.LatLngBounds();

            //bounds.extend(results[0].geometry.viewport.b);
            //bounds.extend(results[0].geometry.viewport.f);
            this.state.map.setZoom(10);

            //this.state.map.fitBounds(results[0].geometry.viewport);
            //this.state.map.panBy(this.findCenterOfScreen(),0)

            this.setState({viewport:results[0].geometry.viewport,enableMap:true,geometry:results[0].geometry})

        //this.findClosestMarker(results[0].geometry)
        

        let markersOnMap = this.getMarkersOnMap();

        if(markersOnMap.length < 5){
           this.findNearbyMarkers(markersOnMap);
        }


        // add listener to map
          this.state.map.addListener('bounds_changed',(e)=>{
           // console.log('bounds_changed')
              //this.getMarkersOnMap(e);

              this.mapUpdate();
          })

      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
        this.props.searchError();
      }

  }



  resetViewToMarkers(){
    console.log('resetViewToMarkers()');
    this.state.map.fitBounds(this.state.viewport);
    this.state.map.panBy(this.findCenterOfScreen(),0)
  }

  findClosestMarker(){

    let mapCenter = this.state.map.getCenter()
    let searchLocation = new window.google.maps.LatLng(mapCenter);
    console.log('findClosestMarker()',searchLocation, this.props.markerList.length);





    if(this.props.markerList){

    let markers = this.props.markerList.slice();

    let markerCount = 0;



     markers.sort((a, b)=>{
          return a.distance - b.distance;
        })

  



       markers = markers.slice(0,5);

       // all markers
       //markersOnMap = markers.slice();


       let bounds = new window.google.maps.LatLngBounds();

       markers.map((item,i)=>{

          let currentLatLong = this.getMarkerLatLong(item)
        let lat = currentLatLong.lat
        let long = currentLatLong.lng


         // use other lat and lang if current one not available


       

         //console.log('item.acf.lat',lat,'item.acf.long',long);



         let closest = new window.google.maps.LatLng(Number(lat),Number(long));
          bounds.extend(closest);

          //console.log('distance',item.title.rendered,item.distance/1000);
        })

        bounds.extend(searchLocation);

        //console.log("Find the closest markers",markersOnMap);

        //this.state.map.setZoom(10);

        //console.log('bounds',bounds);
        this.state.map.fitBounds(bounds, {top:75,right:40,left:40,bottom:40});

    



    

       //console.log('markersOnMap',markersOnMap)


      return  markers

    }



  


    }





  

  



  nonAPIgetDistance(p1, p2) {

    //https://stackoverflow.com/questions/1502590/calculate-distance-between-two-points-in-google-maps-v3

    var rad = function(x) {
      return x * Math.PI / 180;
    };

    var R = 6378137; // Earth’s mean radius in meter
    var dLat = rad(p2.lat() - p1.lat());
    var dLong = rad(p2.lng() - p1.lng());
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  };

  componentDidUpdate(prevProps,prevState){




      // New update on location search
      if(this.state.markerList.length){
        if(prevState.markerList.length){
          if(prevState.markerList[0].id !== this.state.markerList[0].id){
              this.updateMarkers();
          }
        }else{
            this.updateMarkers();
        }
      }

      // update if markers go to 0

        if(this.state.markerList.length==0 && prevState.markerList.length !==0){
            this.updateMarkers();
        }




      if(this.props.searchTerm){
          if(prevProps.searchTerm!==this.props.searchTerm){
            this.searchForPlace();
          }

      }
      //console.log("activeMarker?",prevProps.activeMarker.id , this.props.activeMarker.id);
      if(prevProps.activeMarker.id !== this.props.activeMarker.id){
              this.updateMarkers()

              //this.centerOnActiveMarker()

              //this.highLightMarker(this.props.activeMarker.id);
      }

      if(prevProps.activeMarker.id && this.props.activeMarker===false){
        //alert("Update Markers")
          //this.searchForPlace()
          //this.resetViewToMarkers();
      }

      //console.log('prevProps.activeMarker',prevProps.activeMarker,'this.props.activeMarker',this.props.activeMarker);


      //if(prevProps.activeMarker.id !== this.props.activeMarker.id){
      //console.log('this.props.mouseHoverDealerId',this.props.mouseHoverDealerId);
          this.highLightMarker(this.props.mouseHoverDealerId)
  };






  render() {
    return(
      <div className={"googlemaps "+(this.state.enableMap? " " : " disable")}>

        <div id="map" className="map" />


      </div>
    )
  }
}

export default GoogleMaps



const BrixtonMapStyle = [
    {
        "featureType": "all",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#342023"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#342023"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#603b41"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "weight": 1.2
            },
            {
                "color": "#342023"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#654343"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#654343"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#654343"
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#654343"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#342023"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#603b41"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#1c1113"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "weight": 0.2
            },
            {
                "color": "#1c1113"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#1c1113"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#603b41"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#603b41"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 19
            },
            {
                "color": "#342023"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#0f252e"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#110b0c"
            }
        ]
    }
]
